<template>
  <div class="field">
    <Datepicker
      v-model="theModel"
      dateFormat="dd/mm/yy"
      :inputProps="inputProps"
      class="w-100"
      :inputClass="'custom-input form-control'"
      :class="{ 'p-invalid': v.$error }"
      @blur="v.$touch"
    />
    <small v-if="v.$error || v.$pending.$response" class="p-error">
        {{ $t('registration.requiredValidationError') }}
    </small>
  </div>
</template>

<script>
import Datepicker from "primevue/calendar";
import { computed } from "vue";
import useVuelidate from "@vuelidate/core";

export default {
  components: { Datepicker },
  props: {
    modelValue: String,
    scope: String,
    rules: Object,
    inputProps:Object
  },
  emits: ["update:modelValue", "change"],
  async setup(props, { emit }) {
    const theModel = computed({
      get: () => props.modelValue,
      set: (value) => {
        emit("update:modelValue", value);
        emit("change", { value: value });
      },
    });

    const v = useVuelidate(props.rules, theModel, { $scope: props.scope });

    return { theModel, v };
  },
};
</script>
